var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177.284,
    height: 173,
    viewBox: "0 0 177.284 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 177.284,
    height: 82.874,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 173,
    height: 173,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1925",
    "data-name": "Groupe 1925",
    transform: "translate(-599 -7662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1917",
    "data-name": "Groupe 1917",
    transform: "translate(599 7706.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_671",
    "data-name": "Trac\\xE9 671",
    d: "M33.938,52.518h71.5v3.549h-71.5Zm-1.5,5.043h74.493v-6.54H32.442Z",
    transform: "translate(16.095 25.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 1.496,
    height: 29.2,
    transform: "translate(54.574 47.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 1.496,
    height: 29.2,
    transform: "translate(116.942 47.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_672",
    "data-name": "Trac\\xE9 672",
    d: "M108.658,34.773h-76.2L30.7,27.526h74.061v1.5H32.6l1.031,4.255h73.85l.615-2.545,1.456.35Z",
    transform: "translate(15.23 13.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_673",
    "data-name": "Trac\\xE9 673",
    d: "M58.336,1.5h5.316V4.2H58.336Zm-1.5,4.2h8.309V0H56.838Z",
    transform: "translate(28.198 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1916",
    "data-name": "Groupe 1916",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1915",
    "data-name": "Groupe 1915",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_674",
    "data-name": "Trac\\xE9 674",
    d: "M89.131,32.1h-1.5a22.38,22.38,0,0,0-44.759,0h-1.5a23.876,23.876,0,0,1,47.752,0",
    transform: "translate(20.529 4.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_675",
    "data-name": "Trac\\xE9 675",
    d: "M96.565,30.93H38.521l-1.753-7.249H96.509v1.266l1.42.343ZM39.7,29.434H95.387l1.029-4.256H38.671Z",
    transform: "translate(18.241 11.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_676",
    "data-name": "Trac\\xE9 676",
    d: "M61.767,10.536h-1.5V6.854h-3.66v3.682h-1.5V5.358h6.652Z",
    transform: "translate(27.343 2.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 1.496,
    height: 3.821,
    transform: "translate(85.036 4.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_677",
    "data-name": "Trac\\xE9 677",
    d: "M91.971,60.544H39.953v-22.5l26.007-3.2.09.012,25.922,3.187Zm-50.522-1.5H90.475V39.368L65.96,36.353,41.449,39.368Z",
    transform: "translate(19.821 17.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 81.818,
    height: 1.496,
    transform: "translate(44.876 81.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 1.496,
    height: 21.866,
    transform: "translate(66.089 55.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 1.496,
    height: 21.866,
    transform: "translate(72.405 55.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 1.496,
    height: 21.866,
    transform: "translate(97.666 55.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 1.496,
    height: 21.866,
    transform: "translate(103.983 55.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_678",
    "data-name": "Trac\\xE9 678",
    d: "M68.606,58.519H51.683V39.966l8.458-1.04,8.465,1.04Zm-15.426-1.5h13.93V41.288l-6.969-.854-6.961.854Z",
    transform: "translate(25.641 19.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_679",
    "data-name": "Trac\\xE9 679",
    d: "M68.6,56.272h-1.5V44.31l-6.967-.856-6.963.856V56.272h-1.5V42.986l8.459-1.04,8.464,1.04Z",
    transform: "translate(25.64 20.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 1.496,
    height: 13.571,
    transform: "translate(85.033 63.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_680",
    "data-name": "Trac\\xE9 680",
    d: "M113.787,40.343a22.772,22.772,0,1,1-.836-32.195,22.8,22.8,0,0,1,.836,32.195M81.84,10.017a21.277,21.277,0,1,0,30.081-.782,21.3,21.3,0,0,0-30.081.782",
    transform: "translate(36.965 0.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_681",
    "data-name": "Trac\\xE9 681",
    d: "M106.89,33.686a16.245,16.245,0,1,1-.6-22.967,16.265,16.265,0,0,1,.6,22.967M84.411,12.347a14.749,14.749,0,1,0,20.851-.543,14.767,14.767,0,0,0-20.851.543",
    transform: "translate(39.129 3.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_682",
    "data-name": "Trac\\xE9 682",
    d: "M127.251,52.812c-1.285,1.354-3.136,1.231-4.777.932a9.7,9.7,0,0,1-5.709-3.429L106.648,38.349c-2.294-2.712-4.822-5.41-7.517-8.016-.108-.1-.2-.19-.259-.257l1.083-1.031.215.214c2.73,2.641,5.293,5.374,7.618,8.124l10.124,11.975a8.221,8.221,0,0,0,4.829,2.914c1.791.328,2.781.186,3.423-.489s.732-1.674.31-3.443a8.208,8.208,0,0,0-3.152-4.668l-12.389-9.414a108.41,108.41,0,0,1-8.618-7.27l-.229-.208.992-1.122.259.238a107.128,107.128,0,0,0,8.5,7.171l12.38,9.408a9.709,9.709,0,0,1,3.713,5.519c.384,1.622.6,3.462-.682,4.817",
    transform: "translate(49.053 12.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_687",
    "data-name": "Trac\\xE9 687",
    d: "M0,0H4.973V1.5H0Z",
    transform: "matrix(0.689, -0.725, 0.725, 0.689, 152.008, 45.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_683",
    "data-name": "Trac\\xE9 683",
    d: "M40.869,54.651H31.56V48.613a17.427,17.427,0,0,1-3.965-1.641l-4.27,4.27-6.581-6.583,4.27-4.268a17.41,17.41,0,0,1-1.641-3.966H13.334V27.117h6.038a17.371,17.371,0,0,1,1.641-3.966l-4.27-4.268L23.325,12.3l4.27,4.27a17.282,17.282,0,0,1,3.965-1.641V8.888h9.309v6.04a17.337,17.337,0,0,1,3.965,1.641L49.1,12.3l6.581,6.583L51,23.562,49.947,22.5l3.622-3.622L49.1,14.415l-4.04,4.041-.5-.31a15.82,15.82,0,0,0-4.614-1.911l-.575-.138V10.384H33.056V16.1l-.573.138a15.8,15.8,0,0,0-4.614,1.911l-.5.31-4.041-4.041-4.466,4.467,4.04,4.04-.31.5a15.854,15.854,0,0,0-1.909,4.614l-.138.575H14.83v6.315h5.712l.138.575a15.9,15.9,0,0,0,1.909,4.614l.31.5-4.04,4.04,4.466,4.467,4.041-4.041.5.311a15.878,15.878,0,0,0,4.614,1.909l.573.138v5.712h6.317V48.032h1.5Z",
    transform: "translate(6.615 4.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_684",
    "data-name": "Trac\\xE9 684",
    d: "M31.614,36.177a9.008,9.008,0,1,1,9.007-9.008h-1.5a7.511,7.511,0,1,0-7.511,7.512Z",
    transform: "translate(11.215 9.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_685",
    "data-name": "Trac\\xE9 685",
    d: "M31.362,45.891l-.171-.076-.633,1.406L34.2,48.859l-1.869,4.155L28.44,51.26,28.3,51.2l-.371.482a12.2,12.2,0,0,1-2.793,2.63l-.5.341L26.2,58.786,21.944,60.4l-1.566-4.131-.6.078a12.051,12.051,0,0,1-3.836-.117l-.6-.114-1.813,4.029L9.375,58.277l1.753-3.893.06-.136-.483-.371a12.189,12.189,0,0,1-2.629-2.793l-.343-.5L3.6,52.147,1.987,47.888l4.132-1.566-.079-.6a12.191,12.191,0,0,1,.117-3.838l.114-.6L2.24,39.471l1.87-4.153L8,37.071l.136.061.371-.483a12.213,12.213,0,0,1,2.793-2.63l.5-.341-1.568-4.132L14.5,27.931l1.418,3.736,1.441-.546-1.966-5.178L8.429,28.585l-.175.067L9.942,33.1a13.672,13.672,0,0,0-2.267,2.133L3.338,33.28.28,40.072.2,40.244,4.541,42.2a13.763,13.763,0,0,0-.094,3.109L0,46.993l2.641,6.966.067.175,4.446-1.686a13.832,13.832,0,0,0,2.133,2.264L7.335,59.049l6.792,3.06.172.076,1.952-4.339a13.782,13.782,0,0,0,3.11.1l1.686,4.446,6.966-2.641.175-.067L26.5,55.232A13.838,13.838,0,0,0,28.769,53.1l4.337,1.952,3.058-6.792.076-.171Z",
    transform: "translate(0 12.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_686",
    "data-name": "Trac\\xE9 686",
    d: "M7.992,37.554a7.216,7.216,0,0,0,13.161,5.923l.076-.171-1.406-.631-.078.169a5.674,5.674,0,1,1-7.184-7.632,5.624,5.624,0,0,1,4.339.129l.171.076.633-1.4-.169-.078a7.228,7.228,0,0,0-9.542,3.619",
    transform: "translate(3.649 16.52)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1924",
    "data-name": "Groupe 1924",
    transform: "translate(599 7662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1921",
    "data-name": "Groupe 1921",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_710",
    "data-name": "Trac\\xE9 710",
    d: "M157.23,123.7a84.286,84.286,0,0,1-142.91,0H11.8a86.457,86.457,0,0,0,147.948,0Z",
    transform: "translate(0.724 7.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_711",
    "data-name": "Trac\\xE9 711",
    d: "M11.712,46.385a84.35,84.35,0,0,1,148.432,0h2.384a86.44,86.44,0,0,0-153.2,0Z",
    transform: "translate(0.572 0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.e20b83e33db5165e192b0a117691c0f4.svg";
export { ForwardRef as ReactComponent };